import styled from 'styled-components'
import PropTypes from 'prop-types'

import ColumnGridPanel from 'components/ColumnGridPanel'

import { percentage, friendlyName } from 'helpers/formatters'

const propTypes = {
  report: PropTypes.shape().isRequired
}

const Settings = ({ report }) => {
  const idsDisplayNames = { 'VERY_DRY': 'ON (HIGH)', 'MORE_DRY': 'ON (MED)', 'DRY': 'ON (LOW)', 'NONE': 'OFF' }
  const idsTitle = 'Integrated Dehumidification Solution: activates cooling and electric heat simultaneously, maintaining a preset in-door RH level.'

  const settingsReport = {
    firmwareVersion: report.firmwareVersion,
    fanMode: report.fanMode,
    rhHeatingSetpoint: percentage(report.rhHeatingSetpoint),
    rhCoolingSetpoint: percentage(report.rhCoolingSetpoint),
    ids: report.integratedDehumidificationConfig ? friendlyName(report.integratedDehumidificationUserEnabled ? report.userSetIdsLevel : 'NONE', idsDisplayNames) : null
  }

  const hasData = Object.values(settingsReport).some(val => val !== null)
  if (!hasData) {
    return null
  }

  return (
    <ColumnGridPanel.Column>
      <ColumnGridPanel.Column.Header>Settings</ColumnGridPanel.Column.Header>
      <S.Item label="Firmware" value={settingsReport.firmwareVersion} hideIfValueIsNull />
      <S.Item label="Fan Mode" value={settingsReport.fanMode} hideIfValueIsNull />
      <S.Item label="Htg RH Setpoint" value={settingsReport.rhHeatingSetpoint} hideIfValueIsNull />
      <S.Item label="Clg RH Setpoint" value={settingsReport.rhCoolingSetpoint} hideIfValueIsNull />
      {
        report.integratedDehumidificationConfig &&
        <S.Item
          label="IDS"
          value={settingsReport.ids}
          tooltip={idsTitle}
          hideIfValueIsNull
        />
      }
    </ColumnGridPanel.Column>
  )
}

Settings.propTypes = propTypes

export default Settings

const S = {
  Item: styled(ColumnGridPanel.Column.Item)`
    grid-template-columns: 45% 55%;
  `
}
